export default [
  // { to: '/cerokm/sources', display: 'Sources' },
  { to: '/cerokm/sources', display: 'Sources' },
  { to: '/cerokm/fragments', display: 'Fragments' },
  { to: '/cerokm/factoids', display: 'Factoids' },
  { to: '/cerokm/schema', display: 'Schema' },
  { to: '/cerokm/prompts', display: 'Prompts' },
  { to: '/cerokm/specs', display: 'Specs' },
  { to: '/cerokm/specgroups', display: 'Trims' },
  { to: '/cerokm/add-missing-specs', display: 'Add Missing' },
];
